<template>
  <div>
    <v-app-bar dense flat app text color="#223344" >
      <!-- <v-btn icon small color="white" to="/home">
        <v-icon small >mdi-home</v-icon>
      </v-btn> -->
      <OrganizationMenu> </OrganizationMenu>

      <v-spacer> </v-spacer>
      <UserMenu> </UserMenu>
    </v-app-bar>
  </div>

  <!-- <v-toolbar
    app="app"
    text
    clipped-right="clipped-right"
    color="#3A3A3A"
    dark="dark"
    fixed="fixed"
    height="58"
    extension-height="48"
    ref="toolbar"
    id="app-toolbar"
  >
    <v-btn text to="/home" v-if="$vuetify.breakpoint.smAndUp">
      <v-icon left="left">home</v-icon>Home</v-btn
    >
    <v-btn icon v-else to="/home">
      <v-icon>home</v-icon>
    </v-btn>
    <OrganizationMenu>
</OrganizationMenu>
    <v-spacer>
</v-spacer>
    <UserMenu>
</UserMenu>
  </v-toolbar> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserMenu from "./Menu";
import OrganizationMenu from "./OrganizationMenu";

export default {
  data() {
    return {
      stateless: false
    };
  },
  components: {
    UserMenu,
    OrganizationMenu
  },
  methods: {
    ...mapActions("layout", ["drawerToggle"])
  }
};
</script>

<style scoped></style>
